export default __webpack_public_path__ + "static/media/alarm.0ca0fbc0.svg";